// @flow

import * as React from 'react';

import s from './LinkPrimary.scss';

type Props = {
  text: string,
  disabled: boolean,
  onClick: () => void,
}

export const LinkPrimary = (props: Props) => {
  const { disabled, onClick, text } = props;
  const style = getStyle(disabled);

  return (
    <button
      className={style.join(' ')}
      onClick={() => onClick()}
      disabled={disabled}
    >
      {text}
    </button>
  )
}

function getStyle(disabled: boolean) {
  let style = [s.link]
  if (disabled) {
    style.push(`${s.disabled}`)
  }
  return style;
}


export default LinkPrimary;
